module.exports = __webpack_public_path__ + "img/Pauline.b52352c6.jpeg";